import React, { useEffect, useState } from 'react';
import './GenericToggle.scss';

const GenericToggle = ({
  className = '',
  leftTextClassName,
  rightTextClassname,
  actionFunction,
  actionFunctionValue = (value) => {},
  rightText,
  leftText,
  defaultActive,
  isEditTG,
  loading = false,
  disabled,
  value = null,
  onDisabledFunction = null,
}) => {
  const [active, setActive] = useState(defaultActive);

  const isActive = value ?? active;

  useEffect(() => {
    setActive(defaultActive);
  }, [defaultActive]);

  const handleToggle = () => {
    actionFunction();

    const newValue = !isActive;
    actionFunctionValue(newValue);
    setActive(newValue);
  };

  return (
    <div className={`align-items-center non-selectable switch-container ${className}`}>
      <span
        className={` font-weight-500 text-xs cursor-pointer ${leftTextClassName} ${
          !isActive ? 'toggle-selected-option' : 'toggle-unselected-option'
        }`}
        onClick={() => {
          if (!loading && !disabled) {
            handleToggle();
          } else if (disabled && onDisabledFunction) {
            onDisabledFunction();
          }
        }}
        aria-hidden
      >
        {leftText}
      </span>
      <label
        className={`switch m-0 position-relative d-inline-block mx-1  ${
          loading ? 'cursor-loading' : 'cursor-pointer'
        } ${isActive ? 'switch-active' : 'switch-inactive'} ${isEditTG && 'cursor-not-allowed'}`}
      >
        <input
          type="checkbox"
          data-testid="generic-toggle"
          onChange={() => {
            if (!loading && !disabled) {
              handleToggle();
            } else if (disabled && onDisabledFunction) {
              onDisabledFunction();
            }
          }}
          disabled={isEditTG}
          checked={!isActive}
        />
        <span className=" slider position-absolute" />
      </label>
      <span
        className={` font-weight-500 text-xs cursor-pointer ${rightTextClassname} ${
          isActive ? 'toggle-selected-option' : 'toggle-unselected-option'
        }`}
        onClick={() => {
          if (!loading && !disabled) {
            handleToggle();
          } else if (disabled && onDisabledFunction) {
            onDisabledFunction();
          }
        }}
        aria-hidden
      >
        {rightText}
      </span>
    </div>
  );
};

export default GenericToggle;
